"use client";

import { useEffect } from "react";
import { Button, ButtonIcon, Input, View } from "@/components";
import useDropdown from "@/hooks/useDropdown";

// FIXME: Change html form
const Search = () => {
  const { open, ref, toggleOpen } = useDropdown();

  useEffect(() => {
    const handleKeyboardPress = (event: KeyboardEvent) => {
      if (event.ctrlKey && event.key === "k") {
        event.preventDefault();
        toggleOpen();
      }
    };
    document.addEventListener("keydown", handleKeyboardPress);

    return () => {
      document.removeEventListener("keydown", handleKeyboardPress);
    };
  }, [toggleOpen]);
  return (
    <View className="relative" ref={ref}>
      <ButtonIcon
        action={toggleOpen}
        iconLeft={{ name: "magnifying-glass" }}
        className="p-1.5 sm:p-2 lg:p-3 border rounded-full bg-n0 dark:bg-bg4 border-n30 dark:border-n500"
      />
      <View
        className={`bg-n0 z-10 p-3 sm:p-4 border dark:border-n500 dark:bg-bg4 sm:w-[450px] rounded-md ltr:-right-[150px] ltr:sm:right-0 rtl:sm:left-0 shadow-lg absolute top-[105%] duration-300 ${open ? "visible opacity-100" : "invisible opacity-0"}`}
      >
        <form className="flex gap-4 items-center">
          <Input
            name="Search"
            type="text"
            className="p-2 text-sm border lg:py-2.5 w-full border-n30 bg-transparent dark:bg-bg3 dark:border-n500 rounded-md"
            placeholder="Search ..."
          />{" "}
          <Button className="btn rounded-lg py-2 px-4">Search</Button>
        </form>
      </View>
    </View>
  );
};

export default Search;
